import { render, staticRenderFns } from "./AutoTextarea.vue?vue&type=template&id=4631ab5c&scoped=true&"
import script from "./AutoTextarea.vue?vue&type=script&lang=js&"
export * from "./AutoTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AutoTextarea.vue?vue&type=style&index=0&id=4631ab5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631ab5c",
  null
  
)

export default component.exports